import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import SwipeToDelete from '@/components/shared/SwipeToDelete';
import { ROUTES } from '@/configs/routes';
import { FollowUpEntity } from '@/entities/FollowUp';
import { useSidebarNoteStore } from '@/stores/local/sidebar/SidebarNoteStore';
import { useDevices } from '@/utils/devices';

import BaseItem from '../../common/BaseItem';

type FollowUpItemProps = {
  className?: string;
  model: FollowUpEntity;
  actionSlot?: React.ReactNode;
};

const FollowUpItem: React.FC<FollowUpItemProps> = ({ model, actionSlot, className }) => {
  const { isPhone } = useDevices();
  const navigate = useNavigate();
  const { id, followUpId } = useParams();
  const isActive = followUpId === String(model.id);
  const hasLineThrough = model.isDone;
  const { followUp } = useSidebarNoteStore();

  const handleClick = React.useCallback(() => {
    navigate(ROUTES.organization.notebook.followUps.followUp.create(id as string, String(model.id)), {
      state: {
        detailUpdatedAt: model.updatedAt,
        detailCreatedAt: model.createdAt,
      },
    });
  }, [id, model.createdAt, model.id, model.updatedAt, navigate]);

  const handleDelete = React.useCallback(() => {
    followUp.remove(String(model.id));
  }, [followUp, model.id]);

  return (
    <SwipeToDelete
      isLoading={followUp.popupMeta.isLoading}
      isSuccess={followUp.popupMeta.isLoaded}
      enabled={isPhone}
      onDelete={handleDelete}
    >
      <BaseItem
        hasLineThrough={hasLineThrough}
        className={className}
        isActive={isActive}
        title={model.caption}
        actionSlot={actionSlot}
        onClick={handleClick}
      />
    </SwipeToDelete>
  );
};

export default observer(FollowUpItem);
